
import { ISDKInfo } from '@kentico/kontent-core';
export const sdkInfo: ISDKInfo = {
    host: 'npmjs.com',
    version: '11.13.0',
    name: '@kentico/kontent-delivery'
};
